<div
  id="sell_property_form_step_1"
  [formGroup]="localizationForm"
  class="form-body saler-step-form"
>
  <h4 class="fb-title">
    {{ "components.stepBasics.propertyAddress" | translate }}
  </h4>
  <section class="container-datos columns2">
    <div class="dato">
      <span class="mandatory">
        {{ "components.cardCharacProp.roadType" | translate }}
      </span>
      <mat-select class="w100 large" formControlName="roadType">
        <mat-option [value]="null" hidden selected>
          {{ "components.stepBasics.selectTypeDefault" | translate }}
        </mat-option>
        <mat-option
          *ngFor="let type of roadTypes"
          [value]="type.id_street_type"
        >
          {{ type["description" + language] }}
        </mat-option>
      </mat-select>
    </div>
    <div class="dato">
      <span class="mandatory">
        {{ "components.cardCharacProp.roadName" | translate }}
      </span>
      <input formControlName="street" type="text" class="w100 large" />
    </div>
    <div class="dato">
      <span class="mandatory">{{
        "components.cardCharacProp.number" | translate
      }}</span>
      <input
        formControlName="no_street"
        type="text"
        class="w100 large"
        appMaxLength
        [maxLength]="4"
      />
    </div>
    <div class="dato">
      <span>{{ "components.cardCharacProp.staircase" | translate }}</span>
      <input
        formControlName="ladder"
        appMaxLength
        [allowChars]="true"
        [maxLength]="4"
        type="text"
        class="w100 large"
      />
    </div>
    <div class="dato">
      <span>{{ "components.cardCharacProp.floor" | translate }}</span>
      <input
        formControlName="floor"
        appMaxLength
        [maxLength]="4"
        type="text"
        class="w100 large"
      />
    </div>
    <div class="dato">
      <span>{{ "components.cardCharacProp.door" | translate }}</span>
      <input
        formControlName="door"
        appMaxLength
        [allowChars]="true"
        [maxLength]="4"
        type="text"
        class="w100 large"
      />
    </div>
    <div class="dato">
      <span class="mandatory">
        {{ "components.cardCharacProp.country" | translate }}
      </span>
      <mat-select formControlName="country" class="w100 large">
        <mat-option [value]="null" selected>
          {{ "components.formStepOne.selectCountry" | translate }}
        </mat-option>
        <mat-option
          *ngFor="let country of countries"
          [value]="country.id_country"
        >
          {{ country["description" + language] }}
        </mat-option>
      </mat-select>
    </div>
    <div class="dato">
      <span class="mandatory">
        {{ "components.cardCharacProp.province" | translate }}
      </span>
      <mat-select formControlName="province" class="w100 large">
        <mat-option [value]="null" hidden selected>
          {{ "components.formStepOne.selectProvince" | translate }}
        </mat-option>
        <mat-option
          *ngFor="let province of provinces"
          [value]="province.id_province"
        >
          {{ province.description }}
        </mat-option>
      </mat-select>
    </div>
    <div class="dato">
      <span class="mandatory">
        {{ "components.cardCharacProp.locality" | translate }}
      </span>
      <mat-select formControlName="location" class="w100 large">
        <mat-option [value]="null" hidden selected>
          {{ "components.formStepOne.selectLocation" | translate }}
        </mat-option>
        <mat-option
          *ngFor="let location of locations"
          [value]="location.id_location"
        >
          {{ location.description }}
        </mat-option>
      </mat-select>
    </div>
    <div class="dato">
      <span class="mandatory">{{
        "components.cardCharacProp.postalCode" | translate
      }}</span>
      <input
        formControlName="postal_code"
        appMaxLength
        [maxLength]="6"
        type="text"
        class="w100 large"
      />
    </div>
  </section>
  <div>
    <small
      *ngIf="submited && localizationForm.invalid"
      class="text-danger"
    >
      {{ "components.wizard.mustComplete" | translate }}
    </small>
  </div>
  <button
    type="button"
    class="submit-btn"
    [disabled]="localizationForm.invalid"
    (click)="goToStep.emit(8)"
  >
    {{ "components.encubierto.continue" | translate }}
  </button>
</div>
